export default "__VITE_ASSET__K94OTigR__"